import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorBoundary } from "react-error-boundary";

export const Premed = (props) => {
  const navigate = useNavigate();
  const [openNursing, setOpenNursing] = useState(false);
  const [openEmt, setOpenEmt] = useState(false);
  const [openMed, setOpenMed] = useState(false);

  const handleTrackNavigate = (track) => {
    navigate(`/${track}`);
  };

  const styles = {
    container: {
      backgroundColor: "#d7ffd9",
      color: "#1b5e20",
      minHeight: "100vh",
      padding: "30px",
      paddingTop: "100px"
    },
    sectionWrapper: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "20px",
      marginTop: "30px",
    },
    section: {
      flex: "1 1 calc(50% - 20px)",
      backgroundColor: "white",
      borderRadius: "12px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      padding: "20px",
      textAlign: "left",
    },
    calendarSection: {
      flex: "1 1 100%",
      backgroundColor: "#c8e6c9",
      borderRadius: "12px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      padding: "20px",
      textAlign: "center"
    },
    sectionTitle: {
      fontSize: "2rem",
      fontWeight: "bold",
      color: "#1b5e20",
      marginBottom: "15px",
    },
    sectionText: {
      fontSize: "1.2rem",
      lineHeight: "1.5",
      color: "#2e7d32",
      marginBottom: "20px",
    },
    iframe: {
      border: "none",
      width: "100%",
      maxWidth: "800px",
      height: "600px",
      borderRadius: "10px",
      boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
    },
    footer: {
      marginTop: "30px",
      textAlign: "center",
      fontSize: "1rem",
      color: "#388e3c",
      fontWeight: "bold",
    },
    trackButtonsWrapper: {
      display: "flex",
      gap: "12px",
      marginBottom: "30px",
      justifyContent: "flex-start",
      flexWrap: "wrap",
    },
    trackButton: {
      padding: "6px 14px",
      borderRadius: "8px",
      border: "2px solid #2e7d32",
      backgroundColor: "transparent",
      color: "#1b5e20",
      fontSize: "1.15rem",
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    trackButtonActive: {
      padding: "6px 14px",
      borderRadius: "8px",
      border: "2px solid #1b5e20",
      backgroundColor: "#2e7d32",
      color: "white",
      fontSize: "1.15rem",
      fontWeight: 600,
      cursor: "default",
    },
  };

  return (
    <ErrorBoundary fallback={<div>Something went wrong</div>}>
      <div style={styles.container}>
        <h1 style={{ marginTop: 0, marginBottom: "20px", fontSize: "2.25rem", color: "#1b5e20", fontWeight: "bold", textTransform: "uppercase" }}>Pre-Medical</h1>
        {/* Track Navigation Buttons */}
        <div style={styles.trackButtonsWrapper}>
          <button
            onClick={() => handleTrackNavigate('premed')}
            style={styles.trackButtonActive}
            aria-current="page"
          >
            Pre-Med
          </button>
          <button
            onClick={() => handleTrackNavigate('predent')}
            style={styles.trackButton}
          >
            Pre-Dent
          </button>
          <button
            onClick={() => handleTrackNavigate('prepa')}
            style={styles.trackButton}
          >
            Pre-PA
          </button>
        </div>

        {/* Calendar Section */}
        <section style={styles.calendarSection}>
          <h2 style={styles.sectionTitle}>Calendar</h2>
          <p style={styles.sectionText}>
            Check upcoming events, workshops, and meetings related to Pre-Med opportunities.
          </p>
          {/* Embedded Google Calendar */}
          <div style={{ transform: "scale(0.9)", transformOrigin: "top center" }}>
            <iframe
                src="https://calendar.google.com/calendar/embed?src=c_d1e97f631626a0329b68c8d0d3c08f9895893a1439c47513d36cd7d0d3d16088%40group.calendar.google.com&ctz=America%2FNew_York"
                style={styles.iframe}
                title="Premed Calendar"
            ></iframe>
          </div>  
        </section>

        {/* Opportunities and Certifications */}
        <div style={styles.sectionWrapper}>
          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Opportunities</h2>
            <p style={styles.sectionText}>
              Discover shadowing programs, clinical internships, and volunteer opportunities
              to enhance your pre-med experience.
            </p>
          </section>

          <section style={styles.section}>
            <h2 style={styles.sectionTitle}>Certifications</h2>

            {/* CNA & Patient Care Technician */}
            <button
              onClick={() => setOpenNursing(o => !o)}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left" }}
            >
              <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Certified Nursing Assistant (CNA) &amp; Patient Care Technician</h3>
              <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openNursing ? "▲" : "▼"}</span>
            </button>
            {openNursing && (
              <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                {props.data
                  ? props.data.PreMedCert.nursing.map((d, i) => (
                      <div key={`${d.name}-${i}`}>
                        <h4><a href={d.link}>{d.name}</a></h4>
                      </div>
                    ))
                  : "Loading..."}
              </div>
            )}

            {/* EMT */}
            <button
              onClick={() => setOpenEmt(o => !o)}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
            >
              <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Emergency Medical Technician (EMT)</h3>
              <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openEmt ? "▲" : "▼"}</span>
            </button>
            {openEmt && (
              <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                {props.data
                  ? props.data.PreMedCert.emt.map((d, i) => (
                      <div key={`${d.name}-${i}`}>
                        <h4><a href={d.link}>{d.name}</a></h4>
                      </div>
                    ))
                  : "Loading..."}
              </div>
            )}

            {/* Medical Assistant */}
            <button
              onClick={() => setOpenMed(o => !o)}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
            >
              <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Medical Assistant Certification</h3>
              <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openMed ? "▲" : "▼"}</span>
            </button>
            {openMed && (
              <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                {props.data
                  ? props.data.PreMedCert.med.map((d, i) => (
                      <div key={`${d.name}-${i}`}>
                        <h4><a href={d.link}>{d.name}</a></h4>
                      </div>
                    ))
                  : "Loading..."}
              </div>
            )}
          </section>
        </div>
      </div>
    </ErrorBoundary>
  );
};
